import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { CategoryInventory } from './invCategory.model';
import { SubCategoryInventory } from './invSubCategory.model';
import { ProductInventory } from './invProduct.model';

@Injectable({
  providedIn: 'root'
})
export class ProductcardinvService {

  constructor(private http: HttpClient, private global: Globle) { }

  getInventoryByCategory(categoryType: number, fromDate: any, toDate: any) {
    return this.http.get<CategoryInventory[]>(this.global.APIURL +
      "inventory/getinventorybycategory?categoryType=" + categoryType + "&fromDate=" + encodeURIComponent(fromDate)
      + "&toDate=" + encodeURIComponent(toDate));
  }

  getInventoryBySubCategory(categoryId: number, fromDate: any, toDate: any) {
    return this.http.get<SubCategoryInventory[]>(this.global.APIURL +
      "inventory/getinventorybysubcategory?categoryId=" + categoryId + "&fromDate=" + encodeURIComponent(fromDate)
      + "&toDate=" + encodeURIComponent(toDate));
  }

  getInventoryByProduct(subCategoryId: number, fromDate: any, toDate: any) {
    return this.http.get<ProductInventory[]>(this.global.APIURL +
      "inventory/getinventorybyproduct?subCategoryId=" + subCategoryId + "&fromDate=" + encodeURIComponent(fromDate)
      + "&toDate=" + encodeURIComponent(toDate));
  }
}
